import { Button, MediaModal } from '@nespresso-design-system/components';
import type { ModalOptions, Translations } from '../../config';
import styles from './ProductListHeroBannerModal.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import useMediaQuery from '@/widgets/hooks/useMediaQuery';
import { trackPlpInteraction } from '@/widgets/services/TrackingService.ts';

type ProductListHeroBannerModalProps = ModalOptions & {
  onClose: () => void;
  isOpen: boolean;
};

export default function ProductListHeroBannerModal({
  heading,
  description,
  image,
  cta,
  onClose,
  isOpen
}: ProductListHeroBannerModalProps) {
  const { t } = useTranslations<Translations>();
  const { isMobile } = useMediaQuery();

  return (
    <MediaModal
      id="productListHeroBannerModal"
      closeBtnA11yLabel={t('components.modal.closeBtnA11yLabel')}
      // @ts-ignore DS excluded the type but it exist
      bodyClassName={styles.body}
      isOpen={isOpen}
      position={!isMobile ? 'center' : 'side'}
      onClose={onClose}
      fixedFooter
      contentSlot={
        <>
          <div
            class={styles.image}
            style={{
              '--hero-banner-modal-image-desktop': `url(${image.desktopImage})`,
              '--hero-banner-modal-image-tablet': `url(${image.tabletImage})`,
              '--hero-banner-modal-image-mobile': `url(${image.mobileImage})`
            }}
          />
          <div class={styles.content}>
            <p class={styles.heading}>{heading}</p>
            <p>{description}</p>
          </div>
        </>
      }
      footerSlot={
        <Button
          target={cta.ctaTarget}
          href={cta.ctaLink}
          label={cta.ctaLabel}
          onClick={() =>
            trackPlpInteraction({
              ctaName: cta.ctaLabel,
              clickLocation: 'plp hero banner',
              actionType: 'hero banner modal link click'
            })
          }
          variant="secondary"
        />
      }
    />
  );
}
